import { QueryClient } from "@tanstack/react-query";

const STALE_TIME_MS = 2 * 60 * 1000; // 2 minutes
const GC_TIME_MS = 10 * 60 * 1000; // 10 minutes
const QUERY_RETRY = 1;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME_MS,
      gcTime: GC_TIME_MS,
      retry: QUERY_RETRY,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
  },
});
